<ion-app class="middle">
   <ion-menu contentId="content1" side="start">
      <ion-header>
        <ion-item lines="none" color="primary">            
          <ion-avatar item-start><img src="../../../assets/icon/login.png" name="user" /> </ion-avatar>
          <ion-item lines="none" color="primary">
            <ion-label>
               <h2>{{userName}}</h2>                            
            </ion-label>
          </ion-item>
        </ion-item>    
      </ion-header>

      <ion-content>
         <ion-list *ngFor="let pages of navigate">
            <ion-menu-toggle auto-hide="true">
                <ion-item *ngIf="pages.show" [routerLink]="pages.url"  routerDirection="root" (click)="OpenPage(pages)" >
                    <ion-icon [name]="pages.icon" slot="start" color="primary"></ion-icon>
                       {{pages.title}} 
                </ion-item>
            </ion-menu-toggle>
            </ion-list>
      </ion-content>
  </ion-menu> 
<ion-router-outlet id="content1" main *ngIf='!isIframe'></ion-router-outlet>
</ion-app>
